Vue.asyncComponent('bp-blueprint-editor-side-bar', {
    props: {
        dataProvider: {
            type: Object,
            required: true
        }
    }
}, 'blueprints/editor/bp-blueprint-editor-side-bar.html');
